import React from "react";
import PropTypes from "prop-types";
import {Redirect} from 'react-router';
import {NavLink} from 'react-router-dom';
import Loader from '../Loader/index'

import ReactTable from "react-table";
import "react-table/react-table.css";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
// core components
import GridItem from "components/Grid/GridItem.jsx";
//import Table from "components/Table/Table.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardText from "components/Card/CardText.jsx";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.jsx";
import matchSorter from 'match-sorter';
import Button from "components/CustomButtons/Button.jsx";
import Icon from '@material-ui/core/Icon';
import LocalHospital from "@material-ui/icons/LocalHospital";
import GridContainer from "components/Grid/GridContainer.jsx";
import TagsInput from "react-tagsinput";
import api from "../../api/Api";
import Permissions from '../../util/globalPermissions';
import SweetAlert from "react-bootstrap-sweetalert";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import Tooltip from "@material-ui/core/Tooltip";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {
    mappingUI,
    dashboardRouter,
    isClinicMasterOrClinic,
    clinicmaster_id,
    getClinicUserId, getDateConverter
} from '../../util/globalHelper';
import LinearProgress from '@material-ui/core/LinearProgress';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    }
};

class Reviews extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,//
            element: "",//
            api_status: "",//
            read: false,
            alert: null,
            clickedId: "",
            clinicsData: null,
            clinic_id: null,
            clinicmaster_id: null,
            master_tests: [],
            patientList: null,
            clinicMasterList: null,
            redirect: false,
            redirectOne: false,
            redirectAdd: false,
            loading: true,
            selectedDoctorId: "",
            res: null,
            data: []
        };
        this.handleTags = this.handleTags.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onCheck = this.onCheck.bind(this);
        this.addTest = this.addTest.bind(this);
        this.removeTest = this.removeTest.bind(this);
        this.onChangePrice = this.onChangePrice.bind(this)
        this.hideAlert = this.hideAlert.bind(this)
        this.CreateAlert = this.CreateAlert.bind(this)
    }

    handleTags(regularTags) {
    }


    CallReadApi = () => {
        api.getReviews({}).then(json => {
            this.setState({res: json.data.data}, () => {
                this.setState({
                    data: this.state.res.reviews.map(item => {
                        // patientList: this.state.data.data.map(item => {
                        return {
                            "_id": item._id,
                            "comment": item ? item.comment : "-",
                            "overall_rating": item ? item.overall_rating : "",
                            "name": item && item.patient_id.user_id.name ? item.patient_id.user_id.name : "",
                            "contact": item && item.patient_id.user_id.contact ? item.patient_id.user_id.contact : "",
                            "appointment_date": item && item.appointment_id && item.appointment_id.local_date_string ? item.appointment_id.local_date_string : "",
                            "reviews_date": item && item.created_at ? item.created_at : "",
                            "email": item && item.patient_id.user_id.email ? item.patient_id.user_id.email : "",
                        }
                    })
                })
            })
        });

        isClinicMasterOrClinic() === "" ? api.listClinicMaster().then(json => {
            this.setState({clinicMasterList: json.data.data})
        }) : this.setState({clinicMasterList: {}});
    };

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
        var postBody = {
            "clinic_master_id": this.state.clinicmaster_id ? this.state.clinicmaster_id : "",
            "clinic_id": this.state.clinic_id ? this.state.clinic_id : ""
        };
        if (this.state.clinic_id !== "") {
            api.getReviews(postBody).then(json => {
                this.setState({res: json.data.data}, () => {
                    this.setState({
                        data: this.state.res.reviews.map(item => {
                            // patientList: this.state.data.data.map(item => {
                            return {
                                "_id": item._id,
                                "comment": item ? item.comment : "-",
                                "overall_rating": item ? item.overall_rating : "",
                                "name": item && item.patient_id.user_id.name ? item.patient_id.user_id.name : "",
                                "contact": item && item.patient_id.user_id.contact ? item.patient_id.user_id.contact : "",
                                "appointment_date": item && item.appointment_id && item.appointment_id.local_date_string ? item.appointment_id.local_date_string : "",
                                "reviews_date": item && item.created_at ? item.created_at : "",
                                "email": item && item.patient_id.user_id.email ? item.patient_id.user_id.email : "",
                            }
                        })
                    })
                })
            });
        }
    }

    componentDidMount() {
        this.CallReadApi();
        this.setState({clinicmaster_id: clinicmaster_id(), clinic_id: getClinicUserId()})
    }

    getMyclinicFromClicnicMaster(id) {
        api.getClinicDetailsFromMaster(id).then(json => {
            this.setState({clinicsData: json.data.data.clinicmaster_clinics})
        });
    }

    onSave() {
        var data = this.state.data;
        var Mdata = this.state.master_tests;
        var finalArr = [];
        Mdata.forEach(function (o1) {
            if (data.filter(a => a._id === o1._id).length > 0) {
                finalArr.push(data.find(a => a._id === o1._id))
            }
        });
        let postBody = {
            "clinic_master_id": this.state.clinicmaster_id,
            "clinic_id": this.state.clinic_id,
            "master_tests": finalArr.map(item => {
                return {"master_test_id": item._id, "discounted_price": item.discounted_price, "price": item.price}
            })
        };
        if (this.state.clinicmaster_id !== null && this.state.clinic_id !== null && finalArr.length > 0) {
            api.createClinicTestBulk(postBody).then(json => {
                var msgcolor = {message: "Test Mapped Successfully!", color: "success"};
                this.props.id.generateNotification(msgcolor);
                window.location.reload()
            })
        }
    }

    onChangePrice(type, price, index) {
        var array = this.state.data;
        if (type === "D") {
            array[index].discounted_price = JSON.parse(price);
        } else {
            array[index].price = JSON.parse(price);
        }
        this.setState({data: array});
    }

    addTest(name) {
        var array = this.state.master_tests;
        let obj = {"_id": name};
        this.setState({master_tests: array.concat(obj)})
    }

    removeByAttr(arr, attr, value) {
        var i = arr.length;
        while (i--) {
            if (arr[i]
                && arr[i].hasOwnProperty(attr)
                && (arguments.length > 2 && arr[i][attr] === value)) {
                arr.splice(i, 1);
            }
        }
        return arr;
    };

    removeTest(name) {
        var array = this.state.master_tests;
        this.setState({master_tests: this.removeByAttr(array, "_id", name)});
    }

    onCheck(name, value) {
        const state = this.state;
        state[name] = value;
        value ? this.addTest(name) : this.removeTest(name);
    }


    render() {
        const {data, clinicMasterList, clinicsData, patientList} = this.state;
        if ((this.state.clinicmaster_id && this.state.clinicsData === null) || (this.state.clinicsData !== null && this.state.clinicsData[0].clinic_master_id !== this.state.clinicmaster_id || this.state.clinicsData === [])) {
            this.getMyclinicFromClicnicMaster(this.state.clinicmaster_id)
        }

        const {classes} = this.props;
        if (this.state.clinicMasterList)
            return (
                <div>

                    {this.state.alert}

                    <Grid container>

                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="info" text>
                                    <CardText color="info">
                                        <GridContainer>
                                            <GridItem>
                                                <LocalHospital style={{marginTop: 10}}/>
                                            </GridItem>

                                            <GridItem>
                                                <h4 className={classes.cardTitleWhite}>Reviews</h4>
                                                {/*<p className={classes.cardCategoryWhite}>*/}
                                                {/*List of all Tests*/}
                                                {/*</p>*/}
                                            </GridItem>
                                        </GridContainer>
                                    </CardText>
                                    <span>
                                        <GridContainer>
                                    <GridItem xs={12} sm={6} md={6}>
                                     {isClinicMasterOrClinic() === "" ? <FormControl
                                         fullWidth>
                                         <InputLabel
                                             htmlFor="clinicmaster_id">
                                             Clinic Master
                                         </InputLabel>
                                         <Select
                                             value={this.state.clinicmaster_id}
                                             onChange={this.onChangeSelect}
                                             inputProps={{
                                                 name: "clinicmaster_id",
                                                 id: "clinicmaster_id"
                                             }}>
                                             <MenuItem
                                                 disabled>
                                                 Select Clinic
                                             </MenuItem>
                                             {clinicMasterList.map((x) => {
                                                 return <MenuItem
                                                     key={Math.random()}
                                                     style={{height: "1.8em"}}
                                                     value={x.clinicmaster_id}>{x.clinicmaster_name ? x.clinicmaster_name : "No Name"}</MenuItem>
                                             })}
                                         </Select>
                                     </FormControl> : null}
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={6}>
                                        {isClinicMasterOrClinic() === "" && this.state.clinicsData && this.state.clinicsData[0] && this.state.clinicsData[0].clinic_master_id === this.state.clinicmaster_id ?
                                            <FormControl
                                                fullWidth>
                                                <InputLabel
                                                    htmlFor="clinic_id">
                                                    Clinic
                                                </InputLabel>
                                                <Select
                                                    value={this.state.clinic_id}
                                                    onChange={this.onChangeSelect}
                                                    inputProps={{
                                                        name: "clinic_id",
                                                        id: "clinic_id"
                                                    }}
                                                >
                                                    <MenuItem
                                                        disabled
                                                    >
                                                        Select Clinic
                                                    </MenuItem>
                                                    {clinicsData.map((x) => {
                                                        return <MenuItem key={Math.random()}
                                                                         style={{height: "1.8em"}}
                                                                         value={x._id}>{x.name ? x.name : "No Name"}</MenuItem>
                                                    })}
                                                </Select>
                                            </FormControl>
                                            : null}
                                    </GridItem>
                                        </GridContainer>
                                    </span>
                                </CardHeader>
                                <CardHeader style={{display: 'inline-flex'}}>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h4>Rating</h4>
                                                <h3>{this.state.res !== null ? this.state.res.overall_rating : 0}</h3>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h4>Reviews</h4>
                                                <h3>{this.state.res !== null ? this.state.res.reviews.length : 0}</h3>
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h4>Sent (Opened)</h4>
                                                <h3>{this.state.res !== null ? this.state.res.sms_sent : 0}&nbsp;
                                                    ({this.state.res !== null ? this.state.res.review_open_clicks : 0})</h3>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h4>Conversion</h4>
                                                <h3>{this.state.res !== null ? this.state.res.conversions : 0}</h3>
                                            </GridItem>
                                        </GridContainer>
                                    </GridItem>

                                    <GridItem xs={12} sm={5} md={5}>
                                        <span>5&nbsp;Stars</span><span
                                        className="right">{this.state.res !== null ? this.state.res.ratings["5"] : 0}</span>
                                        <CustomLinearProgress
                                            variant="determinate"
                                            color="success"
                                            value={this.state.res !== null ? this.state.res.ratings["5"] * 100 / this.state.res.reviews.length : 0}
                                        />
                                        4&nbsp;Star<span
                                        className="right">{this.state.res !== null ? this.state.res.ratings["4"] : 0}</span><CustomLinearProgress
                                        variant="determinate"
                                        color="success"
                                        value={this.state.res !== null ? this.state.res.ratings["4"] * 100 / this.state.res.reviews.length : 0}
                                    />
                                        3&nbsp;Star<span
                                        className="right">{this.state.res !== null ? this.state.res.ratings["3"] : 0}</span><CustomLinearProgress
                                        variant="determinate"
                                        color="warning"
                                        value={this.state.res !== null ? this.state.res.ratings["3"] * 100 / this.state.res.reviews.length : 0}
                                    />
                                        2&nbsp;Star<span
                                        className="right">{this.state.res !== null ? this.state.res.ratings["2"] : 0}</span><CustomLinearProgress
                                        variant="determinate"
                                        color="danger"
                                        value={this.state.res !== null ? this.state.res.ratings["2"] * 100 / this.state.res.reviews.length : 0}
                                    />
                                        1&nbsp;Star<span
                                        className="right">{this.state.res !== null ? this.state.res.ratings["1"] : 0}</span><CustomLinearProgress
                                        variant="determinate"
                                        color="danger"
                                        value={this.state.res !== null ? this.state.res.ratings["1"] * 100 / this.state.res.reviews.length : 0}
                                    />
                                    </GridItem>
                                </CardHeader>
                                <CardBody>
                                    {data ?
                                        <ReactTable
                                            data={data}
                                            filterable
                                            defaultFilterMethod={(filter, row) =>
                                                String(row[filter.id]) === filter.value}
                                            columns={[
                                                {
                                                    columns: [
                                                        {
                                                            Header: "Patient Name",
                                                            accessor: "name",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p style={{cursor: 'pointer'}}>
                                                                            {data[index].name ? data[index].name : "No Name"}
                                                                        </p>
                                                                    </div>
                                                                ),
                                                            filterMethod: (filter, rows) =>
                                                                matchSorter(rows, filter.value, {keys: ["name"]}),
                                                            filterAll: true
                                                        },
                                                        {
                                                            Header: "Patient Contact",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p>
                                                                            <b>Contact: </b>{data[index].contact ? data[index].contact : "-"}
                                                                        </p>
                                                                        <p>
                                                                            <b>Email: </b>{data[index].email ? data[index].email : "-"}
                                                                        </p>
                                                                    </div>
                                                                ),
                                                            filterable: false,
                                                            sortable: false,
                                                        },
                                                        {
                                                            Header: "Rating",
                                                            accessor: "overall_rating",
                                                            filterMethod: (filter, rows) =>
                                                                matchSorter(rows, filter.value, {keys: ["overall_rating"]}),
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                    <p style={{cursor: 'pointer'}}>
                                                                        {data[index] ? data[index].overall_rating : "No Rating"}
                                                                    </p>
                                                                </div>),
                                                            filterable: false,
                                                            sortable: false
                                                        },
                                                        {
                                                            Header: "Comment",
                                                            accessor: "comment",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p style={{cursor: 'pointer'}}>
                                                                            {data[index] ? data[index].comment : "No comment"}
                                                                        </p>
                                                                    </div>
                                                                ),
                                                            filterMethod: (filter, rows) =>
                                                                matchSorter(rows, filter.value, {keys: ["comment"]}),
                                                            filterAll: true
                                                        },
                                                        {
                                                            Header: "Appointment Date",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p>{data[index].appointment_date ? getDateConverter(data[index].appointment_date) : "No Date"}</p>

                                                                    </div>
                                                                ),
                                                            filterable: false,
                                                            sortable: false,
                                                        }, {
                                                            Header: "Review Date",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p>{data[index].reviews_date ? getDateConverter(data[index].reviews_date) : "No Date"}</p>

                                                                    </div>
                                                                ),
                                                            filterable: false,
                                                            sortable: false,
                                                        },
                                                        {
                                                            Header: 'Actions',
                                                            id: 'request_state',
                                                            filterable: false,
                                                            sortable: false,
                                                            maxWidth: 160,
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                    <Tooltip
                                                                        id="tooltip-top"
                                                                        title="View"
                                                                        placement="bottom"
                                                                        classes={{tooltip: classes.tooltip}}>
                                                                        <Button type="button" color="info"
                                                                                style={{
                                                                                    padding: 8,
                                                                                    marginLeft: '10%'
                                                                                }}
                                                                                onClick={() => {
                                                                                    this.CreateAlert(data[index]);
                                                                                }}>
                                                                            <Icon
                                                                                style={{fontSize: 20}}>info</Icon>
                                                                        </Button>
                                                                    </Tooltip>
                                                                </div>)
                                                        }
                                                    ]
                                                }
                                            ]}
                                            defaultPageSize={10}
                                            className="-striped -highlight"
                                        />
                                        : null}
                                </CardBody>
                            </Card>
                        </GridItem>
                    </Grid>
                </div>
            );
        else return (<div>
            <Loader/>
        </div>)
    }

    hideAlert() {
        this.setState({
            alert: null
        });
    }

    CreateAlert(item) {
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">{"Review"}</DialogTitle>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12} className="centerDiv" style={{margin: '8px 10px'}}>
                            <FormControl
                                fullWidth>
                                <p><b>Name:</b> {item.name}</p>
                                <p><b>Contact:</b> {item.contact}</p>
                                <p><b>Email:</b> {item.email}</p>
                                <p><b>Rating:</b> {item.overall_rating}</p>
                                <p><b>Comment:</b> {item.comment}</p>
                            </FormControl>
                        </GridItem>
                    </GridContainer><br/>
                    <DialogActions style={{margin: '8px auto'}}>
                        <Button onClick={this.hideAlert}>
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
            )
        });
    }

}

Reviews.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(sweetAlertStyle)(Reviews);



// WEBPACK FOOTER //
// ./src/components/Reviews/Reviews.jsx